import Styles from "./icon.less"
import React, {useRef, useState} from "react"
import classNames from "classnames"

interface IconProps {
    imgSrc: any
    tipsMessage?: string
    onClick: () => void
}

export const Icon: React.FC<IconProps> = ({imgSrc, onClick, tipsMessage}) => {
    const [showTips, setShowTips] = useState<Boolean>(false)

    let tipsFlagRef = useRef<ReturnType<typeof setTimeout>>()

    const tipsClasses = classNames(Styles["tips"], {
        [Styles["show"]]: showTips,
    })

    const handleTipsEnter = () => {
        setShowTips(true)
        console.log("enter", tipsFlagRef.current)
        if (tipsFlagRef.current != null) {
            clearTimeout(tipsFlagRef.current)
        }
    }

    const handleTipsLeave = () => {
        tipsFlagRef.current = setTimeout(() => {
            setShowTips(false)
        }, 0)
    }

    return (
        <div className={Styles["icon-wrapper"]}>
            <img src={imgSrc} onClick={onClick} onMouseLeave={handleTipsLeave} onMouseEnter={handleTipsEnter} />
            {tipsMessage !== undefined && <div className={tipsClasses}>{tipsMessage}</div>}
        </div>
    )
}
